import { Injectable, signal } from "@angular/core";

export interface EvaConfirmOptions {
  message: string;
  header?: string;
  acceptLabel?: string;
  rejectLabel?: string;
  severity?: "primary" | "success" | "warning" | "danger";
  accept?: () => void;
  reject?: () => void;
  /** Appelé si une autre demande remplace celle-ci avant qu'on y réponde (ni accept ni reject). */
  superseded?: () => void;
}

/** Demande de confirmation impérative, affichée par l'unique `<eva-confirm-dialog>` de l'app. */
@Injectable({ providedIn: "root" })
export class EvaConfirmService {
  private readonly pending = signal<EvaConfirmOptions | null>(null);

  readonly request = this.pending.asReadonly();

  confirm(options: EvaConfirmOptions): void {
    const previous = this.pending();
    this.pending.set(options);
    previous?.superseded?.();
  }

  accept(): void {
    const request = this.pending();
    this.pending.set(null);
    request?.accept?.();
  }

  reject(): void {
    const request = this.pending();
    this.pending.set(null);
    request?.reject?.();
  }

  /** Ferme `options` si elle est encore affichée, sans appeler ses callbacks. */
  dismiss(options: EvaConfirmOptions): void {
    if (this.pending() === options) this.pending.set(null);
  }
}
